var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTesla(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tesla") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tesla",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E82127",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7383229,17.0858607 L32.087,22.383 L36.4364956,17.0866924 C36.4364956,17.0866924 43.6703088,17.2371449 50.9815922,20.526528 L51.324338,20.6830283 C49.4212957,23.5403363 45.6481454,24.9472004 45.6481454,24.9472004 C45.391989,22.4297154 43.6178565,21.8129441 37.9932278,21.8129441 L37.9932278,21.8129441 L32.0923161,55 L26.1438325,21.8081203 C20.5569619,21.8121124 18.7849918,22.4288837 18.5273384,24.9465351 C18.5273384,24.9465351 14.7526911,23.539671 12.8513121,20.6823629 C20.2765206,17.2412179 27.7383229,17.0858607 27.7383229,17.0858607 L27.7383229,17.0858607 Z M32.0891557,13 C38.28997,13.0261146 45.4907922,14.0672074 53.1799748,17.109314 C53.1799748,17.109314 52.9382896,17.8571576 51.9981624,19.5492867 C44.9641745,16.4835605 38.093029,15.5090019 32.0899874,15.5549105 C26.0859478,15.5090019 19.2136379,16.4835605 12.1809807,19.5492867 C11.3429834,18.030479 11,17.109314 11,17.109314 C18.6881846,14.0673737 25.8886741,13.0261146 32.0891557,13 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesla);
export default __webpack_public_path__ + "static/media/tesla.3010cc515985b7465a731a8a5d247468.svg";
export { ForwardRef as ReactComponent };